import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import styles from "./GroupTitle.module.css";
import useRefillAreaName from "@coworker/apprestructured/src/multi-order-addons/hooks/useRefillAreaName";

type GroupTitleProps = {
  areaId: string;
};

function GroupTitle({ areaId }: GroupTitleProps) {
  const areaName = useRefillAreaName(areaId);

  return (
    <li className={styles["root"]}>
      <FixaText textStyle="Heading.XS">{areaName}</FixaText>
    </li>
  );
}

export default GroupTitle;
